import moment from 'moment-timezone';

export const CLASSIFICATION = {
  INTERNAL: 'internal',
  CUSTOMER: 'customer',
  TRIAL: 'trial',
  ONBOARDING: 'onboarding',
};

export const TIMEZONES = moment.tz.names();
